import { Component } from '@angular/core';
import { BackendService } from '../../core/services/backend.service';
import { Router } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { CustomDatePipe } from '../../core/pipes/date.pipe';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { provideMomentDateAdapter } from "@angular/material-moment-adapter";
import moment from "moment";
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { MenuBarComponent } from '../../core/components/menu-bar/menu-bar.component';
import { FooterComponent } from '../../core/components/footer/footer.component';
import { DashboardNavComponent } from '../../core/components/dashboard-nav/dashboard-nav.component';


@Component({
  selector: 'app-orders-list',
  imports: [NgSelectModule, FormsModule, MatTableModule, CustomDatePipe, CommonModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, MatNativeDateModule, MenuBarComponent, FooterComponent, DashboardNavComponent],
  templateUrl: './orders-list.component.html',
  styleUrl: './orders-list.component.scss',
  providers: [provideMomentDateAdapter({
    parse: {
      dateInput: ['DD-MM-YYYY', 'DD-MM-YYYY'],
    },
    display: {
      dateInput: 'DD/MM/YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'DD-MM-YYYY',
      monthYearA11yLabel: 'MMMM YYYY',
    },
  }, { useUtc: true })]
})

export class OrdersListComponent {
  isMenuOpen = false;
  selectedLang = 'EN';
  orders: any[] = [];
  displayedColumns = ['id', 'clientEmail', 'date', 'amount', 'status', 'assignedTo', 'actions'];

  //Filters
  selectedStatus = null;
  /**
   * 'All' plus the titles from Fyes_OrderStatuses. Loaded rather than hardcoded
   * so the filter cannot drift from the collection — a title that no longer
   * exists resolves to nothing server-side and silently returns every order.
   */
  statusFilterOptions: string[] = ['All'];
  fromDate: Date | null = null;
  toDate: Date | null = null;
  private destroy$ = new Subject<void>();
  private searchSubject = new Subject<string>();
  searchTerm = '';

  constructor(private router: Router, private backendService: BackendService,) { }

  ngOnInit() {
    this.backendService.getOrders(false).subscribe(orders => {
      this.orders = orders.data.orders;
    });

    this.backendService.getOrderStatuses().subscribe({
      next: (res) => {
        const titles = (res?.data?.statuses ?? []).map((s: { title: string }) => s.title);
        this.statusFilterOptions = ['All', ...titles];
      },
      error: () => { this.statusFilterOptions = ['All']; },
    });

    this.searchSubject
      .pipe(
        debounceTime(400),           // wait 400ms after last keystroke
        distinctUntilChanged(),      // only trigger if value actually changed
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.filterOrders());
  }

  public goTo(page: string) {
    this.router.navigate([`/${page}`]);
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  public onSearchChange(value: string): void {
    this.searchSubject.next(value);
  }

  filterOrders() {
    const filters: any = {};

    filters.status =
      this.selectedStatus && this.selectedStatus !== 'All'
        ? this.selectedStatus
        : null;

    filters.fromDate = this.fromDate ? moment.utc(this.fromDate).startOf('day').toISOString() : null;
    filters.toDate = this.toDate ? moment.utc(this.toDate).endOf('day').toISOString() : null;

    filters.searchTerm = this.searchTerm ? this.searchTerm.trim() : null;
    console.log('Filters applied:', filters);
    this.backendService.filterOrders(filters).subscribe(filteredOrders => {
      this.orders = filteredOrders.data.orders;
    });
  }

  public viewOrder(order: any) {
    this.router.navigate([`dashboard/orders/${order.id}`]);
  }

  public takeOrder(order: any) {
    this.backendService.takeOrder(order.id).subscribe(response => {
      console.log('Order taken successfully:', response);
      this.viewOrder(order);
    });
  }
}
